import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_7yhs4qzxvx: FaireCollectionEntity = {
  token: "pbc_7yhs4qzxvx",
  type: "collection",
  name: "Pre-Order FW26 Girl Collection (Ages 2-6 Years)",
  heroImageUrl:
    "https://cdn.faire.com/fastly/51a95d79f062d0d42a2048f3b9138b86eba72814a5d89a86dba86dac6c100a95.jpeg",
  itemCount: 11,
  description:
    "Crafted from breathable organic woven fabrics, each piece features exquisite design details, refined textures, and a beautiful hand feel. Handmade in India by skilled artisans, it reflects our commitment to ethical production, sustainable materials, and timeless designs.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:17.206Z",
    importedBy: "entity-db-import-collections",
  },
};
